import inventoryImg from './inventoryIcon.svg'
import selectInventoryImg from './selectInventoryIcon.svg'
import AddButtonImg from './AddButtonIcon.svg'
import RemoveButtonImg from './RemoveButtonIcon.svg'
import CrossButtonImg from './CrossButtonIcon.svg'
export const selectInventoryIcon = selectInventoryImg;
export const InventoryIcon = inventoryImg;
export const AddButtonIcon = AddButtonImg;
export const RemoveButtonIcon = RemoveButtonImg;
export const CrossButtonIcon = CrossButtonImg;